import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import type { MissionDraft } from './api/missions';
import type { AuthState } from './auth/AuthProvider';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { auth: undefined! as AuthState },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    missionDraft?: MissionDraft;
  }
}
